<template>
    <div class="o-profile__header u-pt20 u-w100 u-bgTertiary">
        <div class="o-profile__avatar">
            <div class="a-circle -xxl -primaryLighter">
                {{ generateInitials(user?.first_name, user?.last_name) }}
            </div>
        </div>
        <h2 class="o-profile__name u-textCenter u-mt20 u-fs25">
            {{ user?.first_name }}
            {{ user?.last_name }}
        </h2>
        <Level class="-absolute" />
    </div>
    <div class="o-profile__holder u-w100 u-py20 u-overflowYAuto">
        <div class="o-profile__inner u-container">
            <h2 class="o-profile__settingsTitle u-mt20 u-colorSecondary">
                {{ $t('profile.accountSettings') }}
            </h2>
            <ul class="o-profile__attachmentsList u-mt20 m-list -borders u-listUnstyled u-fw500">
                <li class="m-list__item">
                    <a class="m-list__link" href="#/changepassword">
                        <i class='bx bx-lock-alt u-colorPrimary'></i>
                        {{ $t('profile.changePassword') }}
                    </a>
                </li>
                <li class="m-list__item">
                    <a class="m-list__link" href="#/proofcards">
                        <i class='bx bx-list-check u-colorPrimary'></i>
                        {{ $t('proofCard.proofCards') }}
                    </a>
                </li>
                <li class="m-list__item">
                    <a class="m-list__link" href="#/badges">
                        <i class='bx bx-badge-check u-colorPrimary'></i>
                        {{ $t('profile.badges') }}
                    </a>
                </li>
                <li v-if="user?.manager" class="m-list__item">
                    <a class="m-list__link" :href="`#/importantcontacts/${user?.manager}`">
                        <i class='bx bx-user-pin u-colorPrimary'></i>
                        {{ $t('profile.manager') }}
                    </a>
                </li>
                <li class="m-list__item">
                    <a class="m-list__link" :href="user?.logout_link">
                        <i class='bx bx-log-out u-colorPrimary'></i>
                        {{ $t('profile.logout') }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, inject } from 'vue';
import api from '../services/api';
import { generateInitials } from '../utils/globalFunctions';

// Components
import Level from '../components/molecules/LevelPoints.vue';
const user = ref(null);

const emit = defineEmits(['updateHeader']);

const fetchUserInfo = async () => {
    try {
        const response = await api.get('/user-info');
        if (response.status === 200 && response.data.length !== 0) {
            user.value = response.data;
        }
    } catch (error) {
        console.error('Error fetching user info:', error);
    }
};

onMounted(() => {
    fetchUserInfo();
});
</script>